import { dateClnse6, RailwayTimeToNormalTime, RailwayTimeToNormalTime2 } from "../../public/DateClnse";
import { RoundedBtn } from "../../public/Button";
import { Button, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { setAdminId, setCount } from "../../../Slices/AdminSlice";
import { current } from "@reduxjs/toolkit";
import {setPlanForView} from "../../../Slices/planslice";
export const MapIssueLog = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    const IssueType = [
        'API Error',
        'Performance Error',
    ];
    const possibleTasks = [
        'My Plans',
        'User',
    ];
    return e?.map((k, j) => ({
        'S.No': (j + 1),
        issue_date: dateClnse6(new Date(new Date(2024, 0, 1).getTime() + Math.random() * (new Date(2025, 11, 31).getTime() - new Date(2024, 0, 1).getTime()))),
        issue_time: RailwayTimeToNormalTime2(new Date(new Date(2024, 0, 1).getTime() + Math.random() * (new Date(2025, 11, 31).getTime() - new Date(2024, 0, 1).getTime()))),
        issue_type: IssueType[Math.floor(Math.random() * IssueType.length)],
        task: possibleTasks[Math.floor(Math.random() * possibleTasks.length)],
        comments: '-',
        status: [<RoundedBtn col="#008000" txt={'Closed'} />, <RoundedBtn col="#FF3B30" txt={'Open'} />]?.[Math.round(Math.random() * (1 - 1 + 1)) + 0],
    }))
}
export const MapManageUser = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    return e?.map((k, j) => ({
        user_id: k.user_id.toString(),
        user_name: k.user_name,
        email_id: k.email_id,
        subscription_type: k.subscription_type,
        plans_associated: k.plans_associated,
        joined_on: k.joined_on,
        logined_on: k.logined_on,
        verified_status: (
      <RoundedBtn
      style={{
        cursor: 'default'
      }}
        col={k.verified_status ? "#008000" : "#FF3B30"}
        txt={k.verified_status ? "Verified" : "Not Verified"}
      />
    ),
    user_status: (
      <RoundedBtn
        col={k.user_status == "Active" ? "#008000" : "#FF3B30"}
        txt={k.user_status == "Active" ? "Active" : "Deactivated"}
      />
    ),
    }))
}
export const MapManagePlan = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    return e?.map((k, j) => {
        const handleClick = (dispatch) => {
            localStorage.setItem('planId', k.id);
            dispatch(setPlanForView({ id: k.plan_id, isView: true, table: false }));
        };

        return {
            plan_id: k.plan_id,
            plan_name: k.plan_name,
            created_by: k.created_by,
            created_at: k.createdAt,
            users_associated: k.users_associated,
            '': <ViewPlanButton planId={k.id} onClick={handleClick} />
        };
    });
};
const ViewPlanButton = ({ planId, onClick }) => {
    const dispatch = useDispatch();
    return (
        <Link to={`/admin/view-plan`} onClick={() => onClick(dispatch)}>
            <Button 
                disableRipple 
                sx={{ 
                    textTransform: 'capitalize', 
                    minHeight: 'max-content', 
                    minWidth: 'max-content', 
                    height: '26px', 
                    width: '64px', 
                    background: '#FF2800', 
                    color: '#fff', 
                    '&:hover': { background: '#FF2800' }, 
                }}
            >
                View Plan
            </Button>
        </Link>
    );
};
export const MapManageTemplate = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    return e?.map((k, j) => ({
        id: k.id,
        template_id: k.template_id,
        template_name: k.template_name,
        created_by: k.created_by,
        likes: k.likes,
        downloads: k.downloads,
        favourites: k.favourites,
        template_cost: k.template_cost,
        template_status: (
  <RoundedBtn
    col={k.template_status === "Active" ? "#008000" : "#FF3B30"}
    txt={k.template_status === "Active" ? "Active" : "Deactivated"}
  />
),
    }))
}
export const MapMappingRoleFeatures = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    return e?.map((k, j) => ({
        role_id: 'Role_' + (j + 1),
        role_name: 'role',
        feature_id: (j + 1),
        feature_name: 'feature',
    }))
}
export const MapMappingPlanRole = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    return e?.map((k, j) => ({
        plan_role_id: 'Plan_Role_' + (j + 1),
        plan_role_name: 'plan_role',
        report_id: (j + 1),
        report_name: 'report',
    }))
}
export const MapMappingReportCategory = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    return e?.map((k, j) => ({
        report_id: 'Role_' + (j + 1),
        report_name: 'report',
        report_category_id: (j + 1),
        report_category_name: 'report_category',
    }))
}
export const MapMappingPlanFeature = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    return e?.map((k, j) => ({
        plan_id: 'Plan_' + (j + 1),
        plan_name: 'role',
        plan_cost: '$0',
        feature_id: 'feature_' + (j + 1),
        feature_name: 'feature',
    }))
}
export const MapSeparateMapping = (e, tab) => {
    const dispatch = useDispatch()
    // Ensure `id` is an array
    const adminId = useSelector((s) => s?.adminslice?.id);
    const count = useSelector((s) => s?.adminslice?.count);
    // Validate input
    const getData = () => {
        if (!Array.isArray(e) || e.length === 0) {
            switch (tab) {
                case 0: return [{ feature_id: '', feature_name: '', mapping: '' }];
                case 1: return [{ report_id: '', report_name: '', mapping: '' }];
                case 2: return [{ report_category_id: '', report_name: '', mapping: '' }];
                case 3: return [{ feature_id: '', feature_name: '', mapping: '' }];
                default: return [];
            }
        }


        // Map based on tab
        switch (tab) {
            case 0: {
                return e.map((k, j) => ({
                    feature_id: j + 1,
                    feature_name: 'Feature',
                    mapping: (
                        <input
                            type="checkbox"
                            style={{
                                marginRight: "15px",
                                marginLeft: "5px",
                                transform: "scale(1.5)",
                                cursor: "pointer",
                                accentColor: '#FF2800',
                                marginTop: "-7px"
                            }}
                            checked={adminId.includes(j)}
                            // value={true}
                            onClick={() => {
                                dispatch(setAdminId(j));
                            }}
                        />
                    )
                }));
            }

            case 1: {
                return e.map((k, j) => ({
                    report_id: j + 1,
                    report_name: 'Report',
                    mapping: (
                        <input
                            type="checkbox"
                            style={{
                                marginRight: "15px",
                                marginLeft: "5px",
                                transform: "scale(1.5)",
                                cursor: "pointer",
                                accentColor: '#FF2800',
                                marginTop: "-7px"
                            }}
                            checked={adminId.includes(j)}
                            value={true}
                            onClick={() => {
                                dispatch(setAdminId(j));
                            }}
                        />
                    )
                }));
            }

            case 2: {
                return e.map((k, j) => ({
                    report_category_id: j + 1,
                    report_name: 'Report Category',
                    mapping: (
                        <input
                            type="checkbox"
                            style={{
                                marginRight: "15px",
                                marginLeft: "5px",
                                transform: "scale(1.5)",
                                cursor: "pointer",
                                accentColor: '#FF2800',
                                marginTop: "-7px"
                            }}
                            checked={adminId.includes(j)}
                            // value={true}
                            onClick={() => {
                                dispatch(setAdminId(j));
                            }}
                        />
                    )
                }));
            }

            case 3: {
                return e.map((k, j) => ({
                    feature_id: j + 1,
                    feature_name: 'Feature',
                    count: (
                        <TextField
                            value={count[j] || ''}
                            onChange={(event) => dispatch(setCount({ key: j, value: event.target.value }))}
                            InputProps={{ sx: { height: "40px", width: '40px', p: '0 !important', borderColor: "#727272" } }}
                            sx={{ color: "#727272", minWidth: 'max-content', p: '0 !important', '& .MuiOutlinedInput-root': { p: '0 !important' } }}
                        />
                    ),
                    mapping: (
                        <input
                            type="checkbox"
                            style={{
                                marginRight: "15px",
                                marginLeft: "5px",
                                transform: "scale(1.5)",
                                cursor: "pointer",
                                accentColor: '#FF2800',
                                marginTop: "-7px"
                            }}
                            checked={adminId.includes(j)} // Always checked for this case
                            // value={true}
                            onClick={() => {
                                dispatch(setAdminId(j));
                            }}
                        />
                    )
                }));
            }

            default: return [];
        }
    }
    return getData
};
export const MapCustomSubscription = (e) => {
    if (!e || e?.length <= 0) {
        return [];
    }
    return e?.map((k, j) => ({
        user_id: (j + 1),
        user_name: 'User' + (j + 1),
        user_mail: 'User_' + (j + 1) + '@flexidigit.com',
        subscription_name: ['Free (Default)', 'Premium', 'Paid']?.[Math.round(Math.random() * (2 - 0 + 1)) + 0],
        bill_type: 'Monthly',
        subscription_cost: '$20',
    }))
}
export const MapNewSubscription = (e, tab) => {
    const dispatch = useDispatch()
    // Ensure `id` is an array
    const count = useSelector((s) => s?.adminslice?.count);
    const adminId = useSelector((s) => s?.adminslice?.id);
    // Validate input
    const getData = () => {
        if (!Array.isArray(e) || e.length === 0) {
            switch (tab) {
                case 0: return [{ feature_id: '', feature_name: '', mapping: '' }];
                case 1: return [{ report_id: '', report_name: '', mapping: '' }];
                case 2: return [{ report_category_id: '', report_name: '', mapping: '' }];
                case 3: return [{ feature_id: '', feature_name: '', mapping: '' }];
                default: return [];
            }
        }

        return e.map((k, j) => ({
            feature_id: j + 1,
            feature_name: 'Feature',
            count: (
                <TextField
                    value={count[j] || ''}
                    onChange={(event) => dispatch(setCount({ key: j, value: event.target.value }))}
                    InputProps={{ sx: { height: "40px", width: '40px', p: '0 !important', borderColor: "#727272" } }}
                    sx={{ color: "#727272", minWidth: 'max-content', p: '0 !important', '& .MuiOutlinedInput-root': { p: '0 !important' } }}
                />
            ),
            mapping: (
                <input
                    type="checkbox"
                    style={{
                        marginRight: "15px",
                        marginLeft: "5px",
                        transform: "scale(1.5)",
                        cursor: "pointer",
                        accentColor: '#FF2800',
                        marginTop: "-7px"
                    }}
                    checked={adminId.includes(j)} // Always checked for this case
                    // value={true}
                    onClick={() => {
                        dispatch(setAdminId(j));
                    }}
                />
            )
        }));
    }
    return getData
};